import React from 'react';
import { useTranslation } from 'react-i18next';
import { PenTool, Home, Layout, Palette, Search } from 'lucide-react';

const Expertise: React.FC = () => {
  const { t } = useTranslation();

  const items = [
    { key: 'architecture', icon: Home },
    { key: 'renovation', icon: PenTool },
    { key: 'interior', icon: Layout },
    { key: 'artistic', icon: Palette },
    { key: 'research', icon: Search },
  ];

  return (
    <section className="py-20 bg-studio-gray">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {items.map((item) => (
            <div key={item.key} className="flex flex-col items-start space-y-4 group">
              <item.icon strokeWidth={1} className="w-8 h-8 text-gray-400 group-hover:text-black transition-colors" />
              <span className="text-sm font-medium tracking-wide">
                {t(`expertise.${item.key}`)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
